// extracted by mini-css-extract-plugin
module.exports = {"list":"JobList-module-list","borderBetween":"JobList-module-border-between","alternateBackground":"JobList-module-alternate-background"};